import queryString from 'qs';

export const getDailyLogRequest = ({ id }) => {
  const queries = { limit: 10, page: 1, operatorPresenceId: id };

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getDailyLogRequest;
